// To avoid CORS issues the google bucket is proxied in the next.config.js

export const storagePath = (path: string) => `/storage/${path}`;
